import { render, staticRenderFns } from "./EstimatesOldPanelsCollection.vue?vue&type=template&id=73ff5a83&"
import script from "./EstimatesOldPanelsCollection.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPanelsCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports